<template>
  <div class="container-fluid">
    <div
      v-for="attribute in errors"
      v-bind:key="attribute"
      class="alert alert-danger"
    >
      <div v-for="error in attribute" v-bind:key="error">
        {{ error }}
      </div>
    </div>
    <h4 class="m-3">Добавление склада</h4>
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      id="uploadForm"
      name="uploadForm"
      enctype="multipart/form-data"
    >
      <el-form-item label="Название">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="Адрес">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item label="Почта">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="Время работы">
        <el-input v-model="form.work_time"></el-input>
      </el-form-item>
      <el-form-item label="Телефон">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item
        label-width="450px"
        label="Показывать время работы и телефон этого магазина на главной?"
      >
        <el-checkbox v-model="form.main"></el-checkbox>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
      <!--            <el-form-item label="Город">-->
      <!--                <el-select v-model="form.city" filterable allow-create default-first-option placeholder="Select">-->
      <!--                    <el-option-->
      <!--                            v-for="item in cities"-->
      <!--                            :key="item.id"-->
      <!--                            :label="item.title"-->
      <!--                            :value="item.id">-->
      <!--                    </el-option>-->
      <!--                </el-select>-->
      <!--            </el-form-item>-->
      <el-form-item label="Доступна доставка">
        <el-checkbox v-model="form.delivery_available"></el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="(e) => storeStorage(e)"
          >Добавить</el-button
        >
        <el-button @click="back()">Отмена</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "@/store/mutation-types";

export default {
  name: "BannerCreate",
  data: function () {
    return {
      form: {
        title: "",
        address: "",
        delivery_available: false,
        work_time: "",
        phone: "",
        sort: 1,
        activity: true,
        email: "",
        city: "",
        main: false,
      },
      cities: [],
      errors: [],
      status: 0,
    };
  },
  methods: {
    back() {
      this.$router.push("/storages");
    },
    getCities() {
      axios.get("/api/admin/storage/cities").then((response) => {
        this.cities = response.data;
      });
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains("el-button") ? t : t.parentNode;
    },
    storeStorage(e) {
      let data = {
        title: this.form.title,
        address: this.form.address,
        work_time: this.form.work_time,
        phone: this.form.phone,
        activity: this.form.activity,
        delivery_available: this.form.delivery_available,
        sort: this.form.sort,
        email: this.form.email,
        city: this.form.city,
        main: this.form.main,
      };

      const btn = this.getTarget(e);
      btn.style.pointerEvents = "none";

      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .post("/storage", data)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          this.status = response.status;
          this.$router.push("/storages");
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          this.errors = errors.response.data.errors;

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
  },
};
</script>

<style scoped></style>
